import { render, staticRenderFns } from "./BaseGreyBacking.vue?vue&type=template&id=3f98c453&scoped=true&"
import script from "./BaseGreyBacking.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseGreyBacking.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseGreyBacking.vue?vue&type=style&index=0&id=3f98c453&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f98c453",
  null
  
)

export default component.exports